"use strict";
exports.__esModule = true;
exports.getPagingValues = exports.StaticLegend = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var LegendList_1 = require("./LegendList");
var Paging_1 = require("./Paging");
var PositionTypes_1 = require("./PositionTypes");
var helpers_1 = require("./helpers");
var LegendLabelItem_1 = require("./LegendLabelItem");
/**
 * @internal
 */
var StaticLegend = /** @class */ (function (_super) {
    tslib_1.__extends(StaticLegend, _super);
    function StaticLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            page: 1
        };
        _this.showNextPage = function () {
            var updatedPage = _this.state.page + 1;
            _this.props.onPageChanged(updatedPage);
            _this.setState({ page: updatedPage });
        };
        _this.showPrevPage = function () {
            var updatedPage = _this.state.page - 1;
            _this.props.onPageChanged(updatedPage);
            _this.setState({ page: updatedPage });
        };
        _this.renderPaging = function (pagesCount) {
            var page = _this.state.page;
            var buttonOrientation = _this.props.buttonOrientation;
            return (react_1["default"].createElement(Paging_1.Paging, { page: page, pagesCount: pagesCount, showNextPage: _this.showNextPage, showPrevPage: _this.showPrevPage, buttonsOrientation: buttonOrientation }));
        };
        return _this;
    }
    StaticLegend.prototype.render = function () {
        var _a = this.props, enableBorderRadius = _a.enableBorderRadius, containerHeight = _a.containerHeight, _b = _a.onItemClick, onItemClick = _b === void 0 ? noop_1["default"] : _b, position = _a.position, series = _a.series, _c = _a.shouldFillAvailableSpace, shouldFillAvailableSpace = _c === void 0 ? true : _c, label = _a.label, paginationHeight = _a.paginationHeight, customComponent = _a.customComponent;
        var page = this.state.page;
        var classNames = classnames_1["default"]("viz-legend", "static", "position-" + position);
        // Without paging
        if (position === PositionTypes_1.TOP || position === PositionTypes_1.BOTTOM) {
            return (react_1["default"].createElement("div", { className: classNames },
                react_1["default"].createElement("div", { className: "series" },
                    react_1["default"].createElement(LegendList_1.LegendList, { enableBorderRadius: enableBorderRadius, series: series, onItemClick: onItemClick }))));
        }
        var columnNum = position === "dialog" ? 2 : 1;
        var labelHeight = label ? helpers_1.ITEM_HEIGHT : 0;
        var labelComponent = label ? react_1["default"].createElement(LegendLabelItem_1.LegendLabelItem, { label: label }) : null;
        var contentHeight = containerHeight - labelHeight;
        var seriesCount = series.length;
        var _d = helpers_1.calculateStaticLegend(seriesCount, contentHeight, columnNum, paginationHeight), hasPaging = _d.hasPaging, visibleItemsCount = _d.visibleItemsCount;
        var usePaging = hasPaging || customComponent;
        var heightOfAvailableSpace = (visibleItemsCount / columnNum) * helpers_1.ITEM_HEIGHT;
        var heightOfVisibleItems = Math.min(visibleItemsCount / columnNum, seriesCount) * helpers_1.ITEM_HEIGHT;
        var seriesHeight = (shouldFillAvailableSpace ? heightOfAvailableSpace : heightOfVisibleItems) + labelHeight;
        var shouldDisplayCustomComponent = page === 1 && this.hasCustomComponent();
        var pagesCount = this.getPagesCount(series.length, visibleItemsCount);
        if (shouldDisplayCustomComponent) {
            return (react_1["default"].createElement("div", { className: classNames },
                react_1["default"].createElement("div", { className: "series", style: { height: seriesHeight } },
                    labelComponent,
                    customComponent),
                usePaging && this.renderPaging(pagesCount)));
        }
        var _e = exports.getPagingValues(page, visibleItemsCount, series.length, this.hasCustomComponent()), start = _e[0], end = _e[1];
        var pagedSeries = series.slice(start, end);
        var visibleItemsFitOneColumn = shouldItemsFitOneColumn(visibleItemsCount, columnNum, pagedSeries.length);
        var fullClassNames = classnames_1["default"](classNames, {
            "no-width": visibleItemsFitOneColumn
        });
        return (react_1["default"].createElement("div", { className: fullClassNames },
            react_1["default"].createElement("div", { className: "series", style: { height: seriesHeight } },
                labelComponent,
                react_1["default"].createElement(LegendList_1.LegendList, { enableBorderRadius: enableBorderRadius, series: pagedSeries, onItemClick: onItemClick })),
            usePaging && this.renderPaging(pagesCount)));
    };
    StaticLegend.prototype.getPagesCount = function (seriesLength, visibleItemsCount) {
        var defaultPagesCount = Math.ceil(seriesLength / visibleItemsCount);
        return this.hasCustomComponent() ? defaultPagesCount + 1 : defaultPagesCount;
    };
    StaticLegend.prototype.hasCustomComponent = function () {
        return !isNil_1["default"](this.props.customComponent);
    };
    StaticLegend.defaultProps = {
        buttonOrientation: "upDown",
        paginationHeight: helpers_1.STATIC_PAGING_HEIGHT,
        onPageChanged: noop_1["default"]
    };
    return StaticLegend;
}(react_1["default"].PureComponent));
exports.StaticLegend = StaticLegend;
exports.getPagingValues = function (page, visibleItemsCount, seriesLength, hasCustomComponent) {
    var start = hasCustomComponent ? (page - 2) * visibleItemsCount : (page - 1) * visibleItemsCount;
    var end = hasCustomComponent
        ? Math.min(visibleItemsCount * (page - 1), seriesLength)
        : Math.min(visibleItemsCount * page, seriesLength);
    return [start, end];
};
var shouldItemsFitOneColumn = function (visibleItemsCount, columnNum, pagedSeriesLength) {
    return visibleItemsCount / columnNum >= pagedSeriesLength;
};
//# sourceMappingURL=StaticLegend.js.map